import { Injectable, computed, signal } from '@angular/core';

import { ISnackbar } from './snackbar.models';

import { EaStatus } from 'src/app/components/ea-status-bar/ea-status-bar.models';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    public readonly $snackbars = signal<readonly ISnackbar[]>([]);
    public readonly $isVisible = computed(() => this.$snackbars().length > 0);

    private _nextId = 0;

    public show(message: string, statusType: EaStatus): string {
        const id = `${++this._nextId}`;
        const snackbar: ISnackbar = { id, message, statusType };

        this.$snackbars.update((snackbars) => [...snackbars, snackbar]);

        return id;
    }

    public hide(id: string): void {
        this.$snackbars.update((snackbars) => snackbars.filter((snackbar) => snackbar.id !== id));
    }
}
